import { SadWolfGradient } from '../../../svgs/sad-wolf-gradient';
import { ErrorBase, type ErrorBaseProps } from '../error-base';

export interface ErrorCriticalProps
  extends Pick<
    ErrorBaseProps,
    'actionLink' | 'actionButton' | 'errorMessages'
  > {
  /** Needs to be hard coded text since this component is made to handle application-crash level errors, therefore it cannot be localized  */
  body?: ErrorBaseProps['body'];
}

/** This component is made to handle application-crash level errors, therefore it cannot be localized  */
export const ErrorCritical = ({
  actionButton,
  actionLink,
  body,
  errorMessages,
}: ErrorCriticalProps) => {
  const defaultBody = [
    `We're currently experiencing an issue.\nOur team is aware and actively working to resolve it as quickly as possible.`,
    'Thank you for your patience!',
  ];

  return (
    <ErrorBase
      title="Critical Error"
      body={body ?? defaultBody}
      icon={<SadWolfGradient />}
      actionButton={actionButton}
      actionLink={actionLink}
      errorMessages={errorMessages}
    />
  );
};
